import { createAction } from "redux-starter-kit";

import {
  FREEZE_FAILURE,
  FREEZE_REQUEST,
  FREEZE_SUCCESS
} from "../types";
import fetchFactoringProfile from "./fetchFactoringProfile";
import fetchFreezeEvents from "./fetchFreezeEvents";

const freezeReceivables = (factoringId, reason) => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(createAction(FREEZE_REQUEST)());
    const response = await api.factoring.freezeFactoring(factoringId, reason);
    dispatch(createAction(FREEZE_SUCCESS)({ factoringId, response }));
    // Refetch the profile so the derived freeze-state fields (_at / _by /
    // _reason / _scope) on the Factoring entity refresh from the canonical
    // GET /factoring/{id}/ response. The POST /freeze/ response only carries
    // the freeze subset; refetch keeps the entities store as a single source
    // of truth. Also refetch the events list so the new FROZE row shows up
    // in the audit trail without requiring a panel re-mount.
    //
    // Not awaited: both refetches fire in the background so the calling
    // modal can close as soon as the POST succeeds. The panel updates a
    // moment later when the refetches resolve.
    dispatch(fetchFactoringProfile(factoringId));
    dispatch(fetchFreezeEvents(factoringId));
    return response;
  } catch (err) {
    dispatch(createAction(FREEZE_FAILURE)(err));
    throw err;
  }
};

export default freezeReceivables;
